import React, { Component } from "react";
import { Carousel } from "react-bootstrap";
// import { Carousel } from "bootstrap";
import "../Styles/CarouselSliderKaas.css";
// import Juee from "../Images/Juee.PNG"

export default class CarouselSliderKaas extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {/* <div class="container-xl mt-5">
          <div class="row">
            <div class="col-sm-12">
              <h2 className=".h2_Carousel">
                What <b>our customers</b> are saying
              </h2>
              <div id="myCarousel" class="carousel slide">
                <ol class="carousel-indicators">
                  <li
                    data-target="#myCarousel"
                    data-slide-to="0"
                    class="active"
                    aria-current="true"
                    aria-label="Slide 1"
                  ></li>
                  <li data-target="#myCarousel" data-slide-to="1"></li>
                  <li data-target="#myCarousel" data-slide-to="2"></li>
                </ol>

                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Lorem ipsum dolor sit amet, consec adipiscing
                                elit. Nam eusem scelerisque tempor, varius quam
                                luctus dui. Mauris magna metus nec.
                              </p>
                              <p class="overview">
                                <b>Paula Wilson</b>, Media Analyst
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Vestibulum quis quam ut magna consequat
                                faucibus. Pellentesque eget mi suscipit
                                tincidunt. Utmtc tempus dictum. Pellentesque
                                virra.
                              </p>
                              <p class="overview">
                                <b>Antonio Moreno</b>, Web Developer
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item ">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Lorem ipsum dolor sit amet, consec adipiscing
                                elit. Nam eusem scelerisque tempor, varius quam
                                luctus dui. Mauris magna metus nec.
                              </p>
                              <p class="overview">
                                <b>Michael Holz</b>, Seo Analyst
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Vestibulum quis quam ut magna consequat
                                faucibus. Pellentesque eget mi suscipit
                                tincidunt. Utmtc tempus dictum. Pellentesque
                                virra.
                              </p>
                              <p class="overview">
                                <b>Mary Saveley</b>, Web Designer
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Lorem ipsum dolor sit amet, consec adipiscing
                                elit. Nam eusem scelerisque tempor, varius quam
                                luctus dui. Mauris magna metus nec.
                              </p>
                              <p class="overview">
                                <b>Martin Sommer</b>, UX Analyst
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="media">
                          <img src={Juee} class="mr-3" alt="" />
                          <div class="media-body">
                            <div class="testimonial">
                              <p>
                                Vestibulum quis quam ut magna consequat
                                faucibus. Pellentesque eget mi suscipit
                                tincidunt. Utmtc tempus dictum. Pellentesque
                                virra.
                              </p>
                              <p class="overview">
                                <b>John Williams</b>, Web Developer
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="container px-4 mb-4">

        {/* <center> */}
          <div className="row  justify-content-start px-4 mb-4 justify-content-start">

            <div className="col-sm-6 col-md-4 col-lg-3 media">
              <img src={this.props.personImg} className="mr-3 " alt="" />
            </div>
            <div className="col-sm-6 col-md-8 col-lg-9 Carosel_TEXT_ px-0 d-flex flex-column align-items-start">
              {/* {this.props.title} */}
              {this.props.children}
              {/* <p>
                Lorem ipsum dolor sit amet, consec adipiscing elit. Nam eusem
                scelerisque tempor, varius quam luctus dui. Mauris magna metus
                nec.
              </p> */}
            </div>
            {/* <div className="col-sm-2"></div> */}
          </div>
          {/* </center> */}
          {/* <Carousel controls={false}>
            <Carousel.Item interval={1000}>
              <div className="row px-4">
                <div className="col-sm-2 media d-flex justify-content-center">
                  <img src={Juee} className="mr-3 " alt="" />
                </div>
                <div className="col-sm-10">
                  <p>
                    Lorem ipsum dolor sit amet, consec adipiscing elit. Nam
                    eusem scelerisque tempor, varius quam luctus dui. Mauris
                    magna metus nec.
                  </p>
                </div>
              </div>

        
            </Carousel.Item>
            <Carousel.Item interval={500}>
              <div className="row px-4">
                <div className="col-sm-2 media d-flex justify-content-center">
                  <img src={Juee} className="mr-3" alt="" />
                </div>
                <div className="col-sm-10">
                  <p>
                    Lorem ipsum dolor sit amet, consec adipiscing elit. Nam
                    eusem scelerisque tempor, varius quam luctus dui. Mauris
                    magna metus nec.
                  </p>
                </div>
              </div>
          
            </Carousel.Item>
            <Carousel.Item>
   
              <div className="row px-4">
                <div className="col-sm-2 media d-flex justify-content-center">
                  <img src={Juee} className="mr-3 " alt="" />
                </div>
                <div className="col-sm-10">
                  <p>
                    Lorem ipsum dolor sit amet, consec adipiscing elit. Nam
                    eusem scelerisque tempor, varius quam luctus dui. Mauris
                    magna metus nec.
                  </p>
                </div>
              </div>
            </Carousel.Item>
          </Carousel> */}
        </div>
      </div>
    );
  }
}
